export default "__VITE_ASSET__xUkJKb67__"